import State from "@/helpers/pattern/state";
import { Localidad } from "@/models/geograficos/localidad";
import { modelIsModified } from "@/helpers/vue-mc";
import localidadAPI from "@/services/geograficos/localidad";
import CombosAPI from "@/services/catalogos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { setSelectsInactiveDataField } from "@/helpers/form-common";

/**
 * State Pattern for provincia form
 */
export default class LocalidadStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.localidad = new Localidad();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.localidad) || $data.view.action.submit.busy || !modelIsModified($data.localidad);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: provinciaList } } } = await CombosAPI.get({ option: "provincia" });
        $data.view.elem.select.provincia.filteredList = provinciaList ? provinciaList.filter((value) => value.status) : [];
        $data.view.elem.select.provincia.completeList = provinciaList || [];
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.loadSelectsData();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { clave, codigo, nombre, codigopostal, provincia, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("view.commons.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await localidadAPI.save({
              clave
              , codigo
              , nombre: nombre.toUpperCase()
              , codigopostal: codigopostal.join()
              , provincia: provincia ? { clave: Number(provincia) } : null
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.localidadTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, codigo, nombre, codigopostal, provincia, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          // Set options to combos if not are active
          setSelectsInactiveDataField(provincia, "clave", $data.view.elem.select.provincia.completeList, $data.view.elem.select.provincia.filteredList);

          $data.view.elem.select.codigopostal.filteredList = codigopostal.split(",");

          $data.localidad = new Localidad({
            clave
            , codigo
            , nombre
            , codigopostal: codigopostal.split(",")
            , provincia: provincia ? Number(provincia.clave) : null
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, codigo, nombre, codigopostal, provincia, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("view.commons.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await localidadAPI.update({
              clave
              , codigo
              , nombre: nombre.toUpperCase()
              , codigopostal: codigopostal.join()
              , provincia: provincia ? { clave: Number(provincia) } : null
              , status
            });

            $data.$refs.localidadTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/geograficos/localidad/localidad-state.js